import { forwardRef } from 'react';

import Input from '../../../../../../components/input/input';
import { InputTooltip } from '../input-tooltip';

import './styles.scss';

interface BacktestingInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'className' | 'size'
> {
  label?: string;
  errors?: string;
  footer?: string;
  icon?: React.ReactNode;
  suffix?: React.ReactNode;
  tooltip?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'fluid';
  className?: string;
}

export const BacktestingInput = forwardRef<HTMLInputElement, BacktestingInputProps>(
  ({ size = 'sm', className = '', label, tooltip, ...props }, ref) => {
    const inputLabel = label ? (
      <span className="backtesting-input-label">
        <span>{label}</span>
        {tooltip && <InputTooltip content={tooltip} />}
      </span>
    ) : undefined;

    return (
      <Input
        ref={ref}
        label={inputLabel}
        className={`backtesting-form-control backtesting-input--${size} ${className}`.trim()}
        {...props}
      />
    );
  },
);

BacktestingInput.displayName = 'BacktestingInput';
